import { useState, useEffect } from "react";
import { fetchStopsList } from "../services/fetchData.js";
import { startStatus, endStatus } from "../services/statusStore.js";

export default function useStopsList() {
  const [stopsList, setStopsList] = useState([]);

  useEffect(() => {
    let active = true;
    let errorStatusId = null;
    const statusId = startStatus("Loading stops list...");
    fetchStopsList()
      .then((stops) => {
        if (!active) return;
        setStopsList(Array.isArray(stops) ? stops : []);
        endStatus(statusId);
      })
      .catch(() => {
        if (!active) return;
        setStopsList([]);
        endStatus(statusId);
        errorStatusId = startStatus("Failed to load stops list.");
        setTimeout(() => {
          if (errorStatusId !== null) {
            endStatus(errorStatusId);
          }
        }, 4000);
      });
    return () => {
      active = false;
      endStatus(statusId);
      if (errorStatusId !== null) {
        endStatus(errorStatusId);
      }
    };
  }, []);

  return stopsList;
}
